module.exports = __webpack_public_path__ + "static/media/Treenuts.39d5dedd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/Treenuts.svg
// module id = 1119
// module chunks = 0